import React from 'react'

import { Trans } from 'react-i18next'

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

import { Grid, Typography, Box } from '@material-ui/core'

import { Section, Link } from 'components'

import {
  parse as parseQueryString,
  stringify as stringifyQueryString,
} from 'query-string'

const ErrorScreen = ({ error }) => {
  return (
    <Section>
      <Grid container justify="center">
        <Grid item xs={12} sm={7} md={5} lg={5}>
          <Box textAlign="center">
            <Box my={1}>
              <ErrorOutlineIcon style={{ fontSize: '3rem' }} color="primary" />
              <Typography variant="h4">
                <Trans i18nKey={`errors:${error}.title`} />
              </Typography>
            </Box>
            <Box my={1}>
              <Typography>
                <Trans i18nKey={`errors:${error}.body`}>
                  <Link
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      // remove firebase signin link parameters
                      const query = parseQueryString(window.location.search)
                      delete query.apiKey
                      delete query.oobCode
                      delete query.mode

                      const newLocation =
                        window.location.pathname +
                        '?' +
                        stringifyQueryString(query) +
                        window.location.hash

                      window.location = newLocation
                    }}
                  />
                </Trans>
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Section>
  )
}

export default ErrorScreen
